import React from "react";

const CorePreviousBenefitDisclaimerV2: React.FC = () => {
	return (
		<div
			style={{
				padding: "20px",
				border: "1px solid red",
				borderRadius: "8px",
				backgroundColor: "#ffe6e6",
				marginTop: "10px"
			}}
		>
			<div
				style={{
					fontWeight: "bold",
					color: "red",
					fontSize: "18px",
					marginBottom: "10px"
				}}
			>
				Duplicate Enrollment Alert
			</div>
			<p style={{ marginBottom: "10px" }}>
				Our records indicate that you have already enrolled in this plan, so there is no need to resubmit the
				form or re-enroll.
			</p>
			<p
				style={{
					marginBottom: "10px",
					display: "flex",
					alignItems: "center"
				}}
			>
				<span style={{ marginRight: "8px", fontSize: "18px" }}>👉</span>
				To review your existing benefits, please visit the&nbsp;{" "}
				<span style={{ fontWeight: "bold" }}>“Benefit”</span>
				&nbsp;tab.
			</p>

			<p
				style={{
					marginBottom: "10px",
					display: "flex",
					alignItems: "center"
				}}
			>
				<span style={{ marginRight: "8px", fontSize: "18px" }}>👉</span>
				If you wish to make changes to your current enrollment, you may proceed to submit the form with the
				updated details.
			</p>
			<p style={{ fontWeight: "bold" }}>Thank you for your attention.</p>
		</div>
	);
};

export default CorePreviousBenefitDisclaimerV2;
